import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CAPABILITIES } from "@/data/capabilities";
import { Section, SectionHeading } from "@/components/shared/Primitives";
import { revealStaggered, VIEW_TIGHT } from "@/components/shared/motion";

export const CapabilityIndex = ({ overline = "Capabilities", title, lead, testId = "services-section", sectionId = "architecture" }) => (
  <Section id={sectionId} testId={testId}>
    <div className="flex flex-wrap items-end justify-between gap-8">
      <SectionHeading overline={overline} title={title} lead={lead} />
      <Link
        to="/capabilities"
        data-testid="capabilities-all-link"
        className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#06B6D4] transition-colors duration-300 hover:text-[#F4F6FB]"
      >
        All capabilities →
      </Link>
    </div>
    <div className="mt-16 border-t border-white/10">
      {CAPABILITIES.map((c, i) => (
        <motion.div
          key={c.id}
          variants={revealStaggered}
          initial="hidden"
          whileInView="show"
          viewport={VIEW_TIGHT}
          custom={i * 0.08}
        >
          <Link
            to={`/capabilities/${c.slug}`}
            data-testid={`capability-row-${c.slug}`}
            className="group grid items-baseline gap-3 border-b border-white/10 py-10 transition-colors duration-500 hover:border-[#8B5CF6]/40 focus-visible:outline-none focus-visible:border-[#06B6D4] md:grid-cols-[5rem_1fr_1.6fr_auto] md:gap-10"
          >
            <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{c.id}</span>
            <h3 className="font-display text-lg font-semibold uppercase tracking-tight text-[#F4F6FB] transition-colors duration-300 group-hover:text-[#8B5CF6] md:text-2xl">
              {c.name}
            </h3>
            <p className="text-sm leading-relaxed text-[#F4F6FB]/55 md:text-base">{c.summary}</p>
            <ArrowUpRight className="hidden h-5 w-5 text-[#8B5CF6] transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 md:block" />
          </Link>
        </motion.div>
      ))}
    </div>
  </Section>
);

export default CapabilityIndex;
